import { defineStore } from 'pinia'
import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const getDefaultState = () => ({
  token: getToken(),
  name: '',
  avatar: '',
  roles: [],
  userId: null,
  defaultBranch: null,
  userBranches: []
})

export const useUserStore = defineStore('user', {
  state: getDefaultState,

  actions: {
    async Login({ username, password }) {
      const { data } = await login(username.trim(), password)
      const token = `${data.tokenHead}${data.token}`
      setToken(token)
      this.token = token
    },

    async GetInfo() {
      const res = await getInfo()
      const data = res.data

      if (!Array.isArray(data.roles) || data.roles.length === 0) {
        throw new Error('GetInfo: roles must be a non-empty array')
      }

      this.roles = data.roles
      this.name = data.username || ''
      this.avatar = data.icon || ''
      this.userId = data.user_id || null
      this.userBranches = data.branchList || []

      if (Array.isArray(data.branchList) && data.branchList.length > 0) {
        this.defaultBranch = data.branchList[0]
      }

      return data
    },

    async LogOut() {
      try {
        await logout(this.token)
      } finally {
        removeToken()
        this.$reset()
      }
    },

    FedLogOut() {
      removeToken()
      this.$reset()
    }
  }
})
